// ======================================================================
// 📁 File: src/modules/ticket/components/ai/TicketAIContainer.jsx
// Purpose: Floating AI Bubble + slot for TicketAIChatPanel (uses Visitor-AI pattern)
// ======================================================================

import React, { useState } from "react";
import TicketAIChatPanel from "./TicketAIChatPanel";

export default function TicketAIContainer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Bubble */}
      <div
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          bottom: "28px",
          right: "28px",
          width: "68px",
          height: "68px",
          background: "#6A00F4",
          borderRadius: "50%",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "28px",
          zIndex: 9999,
        }}
        title="Open AI Assistant"
      >
        💬
      </div>

      {/* Chat Panel (fullscreen-ish drawer style anchored bottom-right) */}
      {open && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "420px",
            height: "78vh",
            background: "#fff",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            boxShadow: "0 -4px 24px rgba(0,0,0,0.25)",
            zIndex: 99999,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TicketAIChatPanel onClose={() => setOpen(false)} />
        </div>
      )}
    </>
  );
}
